import "./TheApexMethod.module.css";
import ApexNavigation from "@/reusable_sections/Header";
import TheMindBehindApex from "./sections/TheMindBehindApex";
import TheJourneyToTheTop from "./sections/TheJourneyToTheTop";
import CommonQuestions from "./sections/CommonQuestions";
import ApexFooter from "@/reusable_sections/Footer";
export default function TheApexMethodPage() {
  return <div>
      <ApexNavigation />
      <TheMindBehindApex />
      <TheJourneyToTheTop />
      <CommonQuestions />
      <ApexFooter />
    </div>;
}